module.exports = __webpack_public_path__ + "img/brands-wasa-sour.jpg?5283c7b30262c66fc9fb6dd48e8d9272";